module.exports = __webpack_public_path__ + "img/Icon_Tick.b232e6dc.svg";